// src/components/HomePage.js
import React from "react";
import { Carousel } from "react-bootstrap";
import "./carousel.css"

function Carousel1() {
  return (
    <div>
      <Carousel fade controls={false} indicators={true} interval={3000} pause={false} className="item">
        <Carousel.Item className="item">
          <img
            className="d-block w-100 img"
            src="https://i.imgur.com/Khsra4U.jpeg"
            alt="First slide"
            style={{ height: "70vh", objectFit: "cover",width:"100%"}}
          />
          <Carousel.Caption >
            <h3 className="cap1">DAIRY FARM</h3>
            <p className="cap" style={{color:"white"}}>“From every drop, a stream of steady income.
Sustainably growing wealth through dairy.”</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item className="item">
          <img
            className="d-block w-100 img"
            src="https://i.imgur.com/mGs8BCw.jpeg"
            alt="First slide"
            style={{ height: "70vh", objectFit: "cover",width:"100%"}}
          />
          <Carousel.Caption >
            <h3 className="cap1">INTEGRITY</h3>
            <p className="cap" style={{color:"white"}}>Integrity isn’t just our principle — it’s our promise.
Every investment begins and ends with trust.”</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item className="item">
          <img
            className="d-block w-100 img"
            src="https://i.imgur.com/vvws7Hq.png"
            alt="First slide"
            style={{ height: "70vh", objectFit: "cover",width:"100%"}}
          />
          <Carousel.Caption >
            <h3 className="cap1" style={{color:"black"}}>GOLD Investment</h3>
            <p className="cap" style={{color:"black"}}>"Invest in what never fades — Gold.
A legacy of purity, power, and prosperity.”</p>
          </Carousel.Caption>
        </Carousel.Item>

        <Carousel.Item className="item">
          <img
            className="d-block w-100 img"
            src="https://i.imgur.com/fkscNIU.png"
            alt="Second slide"
            style={{ height: "70vh", objectFit: "cover",width:"100%"}}
          />
          <Carousel.Caption className="cap">
            <h3 >REAL ESTATE</h3>
            <p>“Building more than spaces — we build legacies.
Invest in real estate that grows with you.” </p>
          </Carousel.Caption>
        </Carousel.Item >

        <Carousel.Item className="item">
          <img
            className="d-block w-100 img"
            src="https://i.imgur.com/tjc37br.png"
            alt="Third slide"
            style={{ height: "70vh", objectFit: "cover" ,width:"100%"}}
          />
          <Carousel.Caption>
            <h3>Build Your Future with Us</h3>
            <p>Let’s create something amazing together.</p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
}

export default Carousel1;
